import { getZ3kEntityById } from 'z3k-parser/lib/auxiliary';
import { removeIn, setIn } from 'immutable';
import { assertNever, removeNulls } from 'utils';
import { composePhysicalIO, parsePhysicalIO } from 'z3k-parser/lib/input-outputs/utils';
import { seemsLikeObjectId } from 'z3k-parser/lib/id';
export const links_meta = [
    {
        // type id: 0
        field: 'analog_inputs',
        title: 'Датчик',
        name_field: 'name',
        links: {
            'notification_list.[]': { type: 'direct', deleteAction: 'remove' },
            'recovery_list.[]': { type: 'direct', deleteAction: 'remove' },
            'upper_notification_list.[]': { type: 'direct', deleteAction: 'remove' },
            physical_input_num: { type: 'physical_io', deleteAction: 'clear' },
            calibration: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 1
        field: 'wired_temperature_sensors',
        title: 'Цифровой датчик температуры',
        name_field: 'name',
        links: {
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
            'rol_temperature_upper_threshold.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
            'rol_temperature_lower_threshold.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
            'recovery_list.[]': { type: 'direct', deleteAction: 'remove' },
            io_extension_id: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 2
        field: 'guard_zones',
        title: 'Охранная зона',
        name_field: 'name',
        links: {
            'relative_sensor_list.[]': { type: 'direct', deleteAction: 'remove' },
            'relative_triggered_list.[]': { type: 'direct', deleteAction: 'remove' },
            'relative_recovered_list.[]': { type: 'direct', deleteAction: 'remove' },
            'relative_turned_on.[]': { type: 'direct', deleteAction: 'remove' },
            'relative_turned_off.[]': { type: 'direct', deleteAction: 'remove' },
            'buzzer_guard_indicator_list.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 3
        field: 'notifications',
        title: 'Оповещение',
        name_field: 'name',
        links: {
            'recipient_list.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 4
        field: 'users',
        title: 'Пользователь',
        name_field: 'name',
        links: {
            'key_and_radiotag_list.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 5
        field: 'output_actions',
        title: 'Действие с выходом',
        name_field: 'name',
        links: {
            physical_output: { type: 'physical_io', deleteAction: 'clear' },
        },
    },
    {
        // type id: 6
        field: 'boiler_adapters',
        title: 'Адаптер котлов',
        name_field: 'name',
        links: {
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
            'rol_boiler_failure.[]': { type: 'direct', deleteAction: 'remove' },
            'rol_connection_found.[]': { type: 'direct', deleteAction: 'remove' },
            'rol_boiler_restore.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 7
        field: 'radiomodules',
        title: 'Радиомодуль',
        name_field: 'name',
        links: {
            'notification_list.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 8
        field: 'radiosensors',
        title: 'Радиоустройство',
        name_field: 'name',
        links: {
            related_radiomodule_id: { type: 'direct', deleteAction: 'clear' },
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
            'rol_temperature_upper_threshold.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
            'rol_temperature_lower_threshold.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
            'rol_sensor_humidity_out_thresholds.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
            'rol_sensor_humidity_lower_thresholds.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
            'rol_movement_leakage_triggered.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
        },
    },
    {
        // type id: 9
        field: 'commands',
        title: 'Команда',
        name_field: 'name',
        links: {
            objectid: { type: 'direct', deleteAction: 'clear' },
        },
        no_confirm: true,
    },
    {
        // type id: 10
        field: 'web_elements',
        title: 'Веб элемент',
        name_field: 'name',
        links: {
            id_active: { type: 'direct', deleteAction: 'clear' },
            id_passive: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 11
        field: 'scenarios',
        title: 'Сценарий',
        name_field: 'name',
        links: {
            'links.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 12
        field: 'buzzers',
        title: 'Сирена',
        name_field: 'name',
        links: {
            physical_output: { type: 'physical_io', deleteAction: 'clear' },
        },
    },
    {
        // type id: 13
        field: 'guard_indicators',
        title: 'Индикатор охраны',
        name_field: 'name',
        links: {
            physical_output: { type: 'physical_io', deleteAction: 'clear' },
        },
    },
    {
        // type id: 14
        field: 'relay_controls',
        title: 'Релейное управление',
        name_field: 'name',
        links: {
            physical_output: { type: 'physical_io', deleteAction: 'clear' },
        },
    },
    {
        // type id: 15
        field: 'threeway_taps',
        title: 'Сервопривод',
        name_field: 'name',
        links: {
            physical_output1: { type: 'physical_io', deleteAction: 'clear' },
            physical_output2: { type: 'physical_io', deleteAction: 'clear' },
        },
    },
    {
        // type id: 16
        field: 'heating_circuits',
        title: 'Контур терморегуляции',
        name_field: 'name',
        links: {
            air_temp_sensor: { type: 'direct', deleteAction: 'clear' },
            air_temp_sensor_reserve: { type: 'direct', deleteAction: 'clear' },
            water_temp_sensor: { type: 'direct', deleteAction: 'clear' },
            water_temp_sensor_reserve: { type: 'direct', deleteAction: 'clear' },
            dhw_temp_sensor: { type: 'direct', deleteAction: 'clear' },
            dhw_temp_sensor_reserve: { type: 'direct', deleteAction: 'clear' },
            'control_devices.[]': { type: 'direct', deleteAction: 'remove' },
            heat_source: { type: 'direct', deleteAction: 'clear' },
            external_thermostat: { type: 'direct', deleteAction: 'clear' },
            pza: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 17
        field: 'pumps',
        title: 'Насос',
        name_field: 'name',
        links: {
            physical_output: { type: 'physical_io', deleteAction: 'clear' },
            pressure_sensor: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 18
        field: 'tm_keys',
        title: 'Ключ TM',
        name_field: 'name',
        links: {
            'touch_actions.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 19
        field: 'user_roles',
        title: 'Роль',
        name_field: 'name',
        links: {
            'managed_guard_zone_list.[]': { type: 'direct', deleteAction: 'remove' },
            'user_list.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 20
        field: 'heating_modes',
        title: 'Режим отопления',
        name_field: 'name',
        links: {
            water_sensor: { type: 'direct', deleteAction: 'clear' },
            'heating_zones.[].heating_circuit': {
                type: 'direct',
                deleteAction: 'removeParent',
            },
            'heating_zones.[].temperature_setting': {
                type: 'direct',
                deleteAction: 'clear',
            },
            'heating_zones.[].adjusting_sensor': {
                type: 'direct',
                deleteAction: 'clear',
            },
            'heating_zones.[].pza': { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 21
        field: 'day_timetables',
        title: 'Дневная таблица времени',
        name_field: '',
        links: {
            'temp24.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 22
        field: 'week_timetables',
        title: 'Недельная таблица времени',
        name_field: '',
        links: {
            'temp7.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 24
        field: 'io_extensions',
        title: 'Устройство расширения',
        name_field: 'name',
        links: {
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
            'related_list.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 25
        field: 'pzas',
        title: 'ПЗА',
        name_field: 'name',
        links: {},
    },
    {
        // type id: 26
        field: 'boiler_groups',
        title: 'Группы контуров котлов',
        name_field: 'name',
        links: {
            lead_boiler_id: { type: 'direct', deleteAction: 'clear' },
            'boiler_list.[]': { type: 'direct', deleteAction: 'remove' },
            'timetables.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 27
        field: 'analog_temperature_sensors',
        title: 'Аналоговый датчик температуры',
        name_field: 'name',
        links: {
            physical_input_num: { type: 'physical_io', deleteAction: 'clear' },
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
            'rol_temperature_upper_threshold.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
            'rol_temperature_lower_threshold.[]': {
                type: 'direct',
                deleteAction: 'remove',
            },
            'recovery_list.[]': { type: 'direct', deleteAction: 'remove' },
            ntc: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 28
        field: 'ntc_temperature_curves',
        title: 'NTC-кривая температуры',
        name_field: '',
        links: {},
    },
    {
        // type id: 29
        field: 'fobs',
        title: 'Фоб',
        name_field: 'name',
        links: {},
    },
    {
        // type id: 30
        field: 'fob_buttons',
        title: 'Кнопка брелока',
        name_field: 'name',
        links: {
            'commands.[]': { type: 'direct', deleteAction: 'remove' },
            fob_id: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 31
        field: 'radiosensors433',
        title: 'Радиоустройство 433МГц',
        name_field: 'name',
        links: {
            'rol_triggered.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 33
        field: 'time_intervals',
        title: 'Временной интервал',
        name_field: '',
        links: {
            temperature: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 34
        field: 'interval_timetables',
        title: 'Интервальное расписание',
        name_field: '',
        links: {
            'time_intervals.[]': { type: 'direct', deleteAction: 'remove' },
            outside_default: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 35
        field: 'analog_duts',
        title: 'Аналоговый датчик уровня топлива',
        name_field: 'name',
        links: {
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
            calibration: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 36
        field: 'calibration_tables',
        title: 'Калибровочная таблица',
        name_field: '',
        links: {},
    },
    {
        // type id: 37
        field: 'digital_duts',
        title: 'Цифровой ДУТ',
        name_field: 'name',
        links: {
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 38
        field: 'radio_duts',
        title: 'Радио датчик уровня топлива',
        name_field: 'name',
        links: {
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
            calibration: { type: 'direct', deleteAction: 'clear' },
            related_radiomodule_id: { type: 'direct', deleteAction: 'clear' },
            'common_with.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 39
        field: 'graph_panels',
        title: 'Графическая панель',
        name_field: 'name',
        links: {
            circuit_id_in_main_panel: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 40
        field: 'boiler_cascades',
        title: 'Каскад котлов',
        name_field: 'name',
        links: {
            'boiler_list.[]': { type: 'direct', deleteAction: 'remove' },
            water_sensor: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 42
        field: 'ui_groups',
        title: 'Пользовательская вкладка',
        name_field: 'name',
        links: {
            'items.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 43
        field: 'object_arrays',
        title: 'Список объектов',
        name_field: 'name',
        links: {
            'objects_links.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 45
        field: 'pauses',
        title: 'Пауза',
        name_field: 'id',
        links: {},
    },
    {
        // type id: 46
        field: 'conditional_operators',
        title: 'Объект сценария - оператор условия',
        name_field: 'id',
        links: {
            comparator_id: { type: 'direct', deleteAction: 'clear' },
            'statementThen.[]': { type: 'direct', deleteAction: 'remove' },
            'statementElse.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 47
        field: 'comparators',
        title: 'Объект сценария - оператор сравнения',
        name_field: 'id',
        links: {
            left_object_id: { type: 'direct', deleteAction: 'clear' },
            right_object_id: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 48
        field: 'logic_expressions',
        title: 'Объект сценария - логическая операция',
        name_field: 'id',
        links: {
            'conditions.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 49
        field: 'sensor_readings',
        title: 'Объект сценария - значения датчика',
        name_field: 'id',
        links: {
            obj_id: { type: 'direct', deleteAction: 'clear' },
            argument: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        // type id: 50
        field: 'time_comparators',
        title: 'Объект сценария - оператор сравнения времени',
        name_field: 'id',
        links: {
            'conditions.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 51
        field: 'modbus_devices',
        title: 'Устройство ModBus',
        name_field: 'name',
        links: {
            'signals.[]': { type: 'direct', deleteAction: 'remove' },
            'rol_connection_lost.[]': { type: 'direct', deleteAction: 'remove' },
            'rol_reconnection.[]': { type: 'direct', deleteAction: 'remove' },
        },
    },
    {
        // type id: 52
        field: 'modbus_signals',
        title: 'ModBus-сигнал',
        name_field: 'name',
        links: {},
    },
    {
        // type id: 53
        field: 'analog_outputs',
        title: 'Аналоговый выход',
        name_field: 'name',
        links: {
            physical_output: { type: 'physical_io', deleteAction: 'clear' },
        },
    },
    {
        // type id: 56
        field: 'stop_scenarios',
        title: 'Прерывание сценария',
        name_field: 'id',
        links: {
            return_id: { type: 'direct', deleteAction: 'clear' },
        },
    },
    {
        field: 'mqtt_topics',
        title: 'MQTT',
        name_field: 'name',
        links: {},
    },
];
// This might be expressed as a generator, but returning an array
// seems to be more convenient for being used in functional expressions
export function getFieldPathValues(obj, fieldName) {
    const components = fieldName.split('.');
    const result = [];
    function doVisit(curObj, componentIndex, realPath) {
        if (componentIndex == components.length) {
            result.push({ path: realPath, value: curObj });
            return;
        }
        if (components[componentIndex] == '[]') {
            curObj.forEach((el, index) => doVisit(el, componentIndex + 1, [...realPath, index]));
        }
        else {
            const propName = components[componentIndex];
            if (Object.prototype.hasOwnProperty.call(curObj, propName)) {
                doVisit(curObj[propName], componentIndex + 1, [...realPath, propName]);
            }
        }
    }
    doVisit(obj, 0, []);
    return result;
}
function getLinkedId(linkType, raw_value) {
    switch (linkType) {
        case 'direct':
            if (seemsLikeObjectId(raw_value)) {
                return raw_value;
            }
            else {
                return null;
            }
        case 'physical_io':
            if (raw_value == null) {
                return null;
            }
            return parsePhysicalIO(raw_value).block_id;
        default:
            return assertNever(linkType);
    }
}
function replaceIdInLink(linkType, oldRawValue, newId) {
    switch (linkType) {
        case 'direct':
            return newId;
        case 'physical_io':
            if (oldRawValue == null || newId == null) {
                // oldRawValue == null -> link was invalid
                // newId == null -> we should invalidate link, not just
                //      change block_id to null, because in most cases
                //      user must notice this invalidation and react
                //      appropriately.
                return composePhysicalIO(newId, null);
            }
            return composePhysicalIO(newId, parsePhysicalIO(oldRawValue).input_number);
        default:
            return assertNever(linkType);
    }
}
/**
 * @function allLinksToObjectId - посещаем все объекты с заданным ID
 * @param config - текущий Z3KConfig
 * @param object_id - ID объекта
 */
function allLinksToObjectId(config, object_id) {
    // Бегу по всем объектам у которых есть links
    return links_meta.flatMap((metaLink) => 
    // Беру все объекты этого типа
    // z3kConfig['analog_inputs'] = {analog_inputs: [...]}
    (config[metaLink.field] ?? []).flatMap(
    // идём по всем объектам этого массива (например, по каждому AnalogInput)
    (object, objIndex) => 
    // Идём по всем полям с ссылками
    Object.entries(metaLink.links).flatMap(
    // путь к полю и тип ссылки
    ([fieldPath, linkSpec]) => 
    // итерируем значения поля (одно для простых прямых ссылок, либо несколько
    // для в случае массива ссылок или ссылки в массиве подобъектов)
    getFieldPathValues(object, fieldPath).flatMap(({ path, value }) => {
        if (typeof value != 'number' ||
            getLinkedId(linkSpec.type, value) != object_id)
            return [];
        return [
            {
                object,
                objIndex,
                metaLink,
                linkSpec,
                fieldName: path,
                linkValue: value,
            },
        ];
    }))));
}
/**
 * @function findLinksConfirmDelete - находим объекты, которые ссылаются на удаляемый
 * @param config - текущий Z3KConfig
 * @param delete_obj_id - ID объекта, который хотим удалить
 * @return string[] - массив с предупреждениями об удалении
 */
export function findLinksConfirmDelete(config, delete_obj_id) {
    return allLinksToObjectId(config, delete_obj_id)
        .filter(({ metaLink }) => !metaLink.no_confirm)
        .map(({ object, metaLink }) => `${metaLink.title} «${object[metaLink.name_field]}» содержит ссылку на данный объект`);
}
export function hasLinksTo(config, object_id) {
    return findLinksConfirmDelete(config, object_id).length > 0;
}
export function hasLinksToObject(config, object) {
    return findLinksConfirmDelete(config, object.id).length > 0;
}
/**
 * @function findAndChangeLinks - находим объекты, которые надо поменять
 * @param config - текущий Z3KConfig, который остаётся неизменным
 * @param delete_obj_id - ID объекта, который хотим удалить
 * @param replace_obj_id - ID объекта, на который хотим заменить
 * @param config_for_edit - Z3KConfig
 * @return config - обновленный Z3KConfig
 */
export function findAndChangeLinks(config, delete_obj_id, replace_obj_id = null, config_for_edit = null) {
    return allLinksToObjectId(config, delete_obj_id).reduce((editedConfig, { objIndex, metaLink, linkSpec, fieldName, linkValue }) => {
        if (replace_obj_id != null) {
            return setIn(editedConfig, [metaLink.field, objIndex, ...fieldName], replaceIdInLink(linkSpec.type, linkValue, replace_obj_id));
        }
        switch (linkSpec.deleteAction) {
            case 'clear':
                return setIn(editedConfig, [metaLink.field, objIndex, ...fieldName], replaceIdInLink(linkSpec.type, linkValue, replace_obj_id));
            case 'remove': {
                return removeIn(editedConfig, [
                    metaLink.field,
                    objIndex,
                    ...fieldName,
                ]);
            }
            case 'removeParent': {
                return removeIn(editedConfig, [
                    metaLink.field,
                    objIndex,
                    ...fieldName.slice(0, fieldName.length - 1),
                ]);
            }
            default:
                assertNever(linkSpec.deleteAction);
        }
    }, config_for_edit ?? config);
}
/**
 * @function findLinks - находим все ID, где использовался этот объект
 * @param config - текущий Z3KConfig
 * @param obj_id - ID объекта
 * @return AnyObjectId[] - массив Id
 */
export function findLinks(config, obj_id) {
    return allLinksToObjectId(config, obj_id).map(({ object }) => object.id);
}
/**
 * @function
 * находим ID, которые используются в этом объекте (не рекурсивно!)
 * @param config - текущий Z3KConfig
 * @param obj_id - ID объекта
 * @return AnyObjectId[] - массив Id
 */
export function findLinksInObject(config, obj_id) {
    //Узнаю тип и нахожу элемент
    const [type, z3k_item] = getZ3kEntityById(config, obj_id);
    //Нахожу, где лежат ссылки у этого объекта
    const need_meta_link = links_meta.find((meta_link) => meta_link.field === type);
    if (need_meta_link == null) {
        return [];
    }
    const ids = Object.entries(need_meta_link.links).flatMap(([fieldPath, linkSpec]) => getFieldPathValues(z3k_item, fieldPath).map(({ value }) => typeof value == 'number' ? getLinkedId(linkSpec.type, value) : null));
    return [...new Set(removeNulls(ids))];
}
